import {isNullOrUndefined} from "../../../components/common/commonUtilities";

export function isPageDependenciesLoaded(pageObjectsNeeded, districtPie, districtPieId) {
    const missingOrWrongObjects = pageObjectsNeeded.some(s => isNullOrUndefined(s)) || isNullOrUndefined(districtPie) || districtPieId !== districtPie.districtPieId;
    return !missingOrWrongObjects;
}

export const getDistrictPiePageSubTitle = (pageSubTitle, districtPie) => {
    return `${pageSubTitle} (${districtPie.dateCovered})`;
};